import {useMount} from '@s-ui/react-hooks'
import Layout from '@adv-mt/mt-layout-basic'
import SpinnerBasic, {spinnerBasicOverlayTypes} from '@adv-mt/mt-spinner-basic'

import {defaultTopbarProps} from '../settings.js'

const Skeleton = () => {
  useMount(() => {
    window.scrollTo(0, 0)
  })
  return (
    <main>
      <Layout.FullWidth footerProps={{isSimple: true}} topbarProps={defaultTopbarProps}>
        <Layout.Container isFullWidth isFullHeight>
          <SpinnerBasic overlayType={spinnerBasicOverlayTypes.LIGHT} />
        </Layout.Container>
      </Layout.FullWidth>
    </main>
  )
}

export default Skeleton
